import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import java from "../assets/java.svg"

import circle from "../assets/circle.svg";

import sanjeet from "../assets/sanjeet.png";

const images = {
	email,
	mobile,
	api,
	css,
	figma,
	git,
	html,
	javascript,
	node,
	react,
	redux,
	java,
	circle,
	sanjeet,
};

export default images;
